import Footer from "../components/footer";
import Header from "../components/header";
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import pdfFile from "../docs/TERMS AND CONDITIONS Insta-Buy V1.0.pdf"; 

const TCUsers =()=>{

    return(
        <>
        <Header />
            <section className="pageheader">
                <div className="container">
                    <h2 className="heading" data-aos="zoom-in" data-aos-duration="700">Terms and Conditions - Insta-Buy</h2>
                </div>
            </section>
            <section className="dark_theam mt-1">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">                    
                            <Worker workerUrl="/pdf.worker.min.js">
                                <div style={{ height: '600px', width: '100%' }}>
                                    <Viewer fileUrl={pdfFile} />
                                </div>
                            </Worker>
                        </div> 
                    </div>
                </div>
            </section>
        <Footer />
        </>
    )

};
export default TCUsers;
